import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  body: {
    paddingTop: '60px'
  },
  tablist: {
    borderTop: 'solid 2px #f5f5f5',
    '& .MuiAppBar-colorPrimary': {
      color: '#000',
      backgroundColor: '#fff'
    },
    '& .MuiTab-wrapper': {
      textTransform: 'capitalize'
    },
    '& .Mui-selected': {
      color: '#ff3a59 !important',
      fontWeight: '600'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#ff3a59 !important',
      height: '3px'
    },
    '& .MuiTabs-scroller': {
      overflow: 'auto !important'
    }
  },
  content: {
    maxWidth: '100%',
    overflow: 'auto',
    '& p': {
      marginBottom: 0
    }
  }
})

export { useStyles }
